"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const mobx_1 = require("mobx");
const crossfilter = require("crossfilter2");
const Fuse = require("fuse.js");
const lodash_1 = require("lodash");
class FilterView {
    constructor(filterable, initialFilters, searchOptions, addDimensions) {
        this.filterable = filterable;
        this.initialFilters = initialFilters;
        this.searchOptions = searchOptions;
        this.addDimensions = addDimensions;
        this.filters = this.initialFilters();
    }
    static basic(filterable, initialFilters, addDimensions) {
        return new FilterView(typeof filterable === 'function' ? filterable : () => filterable, typeof initialFilters === 'function'
            ? initialFilters
            : () => initialFilters, { keys: [] }, addDimensions || ((cf) => cf));
    }
    fork(filtersTransform, addDimensions) {
        const filters = filtersTransform ? filtersTransform(Object.assign({}, this.filters)) : Object.assign({}, this.filters);
        const forked = new FilterView(this.filterable, () => filters, this.searchOptions, (cf, filters) => {
            let result = this.addDimensions(cf, filters);
            if (addDimensions)
                result = addDimensions(result, filters);
            return result;
        });
        forked.setSearchText(this.searchText);
        forked.setSort(this.sorting);
        mobx_1.autorun(() => {
            const filters = filtersTransform
                ? filtersTransform(Object.assign({}, this.filters))
                : Object.assign({}, this.filters);
            forked.setFilters(filters);
        });
        mobx_1.reaction(() => this.searchText, (searchText) => forked.setSearchText(searchText));
        mobx_1.reaction(() => this.sorting, (sorting) => forked.setSort(sorting));
        return forked;
    }
    setSearchText(searchText) {
        this.searchText = searchText;
    }
    clearSearch() {
        this.searchText = undefined;
    }
    clearFilters() {
        this.filters = this.initialFilters();
    }
    setFilters(filters) {
        Object.assign(this.filters, filters);
    }
    setSort(sorting) {
        this.sorting = sorting;
    }
    setSortFn(fn) {
        this.setSort((filtered) => filtered.sort(fn));
    }
    setSortBy(key, reverse = false) {
        if (reverse) {
            this.setOrderBy(key, 'desc');
        }
        else {
            this.setSort((filtered) => lodash_1.sortBy(filtered, key));
        }
    }
    setOrderBy(keys, ordering) {
        const iteratees = Array.isArray(keys) ? keys : [keys];
        const orders = Array.isArray(ordering) ? ordering : [ordering];
        this.setSort((filtered) => lodash_1.orderBy(filtered, iteratees, orders));
    }
    get unfiltered() {
        return this.filterable();
    }
    // note that these properties are split apart so that only the properties
    // necessary are recomputed when filters change
    //
    // text search is the cheapest, because `this.fuse` is layered on top of everything else
    get crossfilter() {
        return this.addDimensions(crossfilter(this.filterable()), this.filters);
    }
    get crossfilterResults() {
        return this.crossfilter.allFiltered();
    }
    get fuse() {
        return new Fuse(this.crossfilterResults, this.searchOptions);
    }
    get filtered() {
        const filtered = this.searchText && this.searchText.length > 0
            ? this.fuse.search(this.searchText)
            : this.crossfilterResults;
        if (this.sorting) {
            return this.sorting(filtered);
        }
        return filtered;
    }
}
__decorate([
    mobx_1.observable,
    __metadata("design:type", Function)
], FilterView.prototype, "sorting", void 0);
__decorate([
    mobx_1.observable,
    __metadata("design:type", String)
], FilterView.prototype, "searchText", void 0);
__decorate([
    mobx_1.action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], FilterView.prototype, "setSearchText", null);
__decorate([
    mobx_1.action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], FilterView.prototype, "clearSearch", null);
__decorate([
    mobx_1.observable,
    __metadata("design:type", Object)
], FilterView.prototype, "filters", void 0);
__decorate([
    mobx_1.action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], FilterView.prototype, "clearFilters", null);
__decorate([
    mobx_1.action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], FilterView.prototype, "setFilters", null);
__decorate([
    mobx_1.action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Function]),
    __metadata("design:returntype", void 0)
], FilterView.prototype, "setSort", null);
__decorate([
    mobx_1.action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Function]),
    __metadata("design:returntype", void 0)
], FilterView.prototype, "setSortFn", null);
__decorate([
    mobx_1.action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], FilterView.prototype, "setSortBy", null);
__decorate([
    mobx_1.action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], FilterView.prototype, "setOrderBy", null);
__decorate([
    mobx_1.computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], FilterView.prototype, "unfiltered", null);
__decorate([
    mobx_1.computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], FilterView.prototype, "crossfilter", null);
__decorate([
    mobx_1.computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], FilterView.prototype, "crossfilterResults", null);
__decorate([
    mobx_1.computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], FilterView.prototype, "fuse", null);
__decorate([
    mobx_1.computed,
    __metadata("design:type", Array),
    __metadata("design:paramtypes", [])
], FilterView.prototype, "filtered", null);
exports.FilterView = FilterView;
exports.default = FilterView;
//# sourceMappingURL=filter-view.js.map